export class AdUser{
    adUsername?: string;
    adOfficeId?: number;
}

export class AdUserForGrid{
    adUsername?: string;
    adOffice?: string;
}

export class AdUsers{
    adUsers?: AdUser[];
}